const data = {
	"width": 24,
	"height": 24,
	"body": "<path fill=\"currentColor\" d=\"m12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8l-8-8z\"/>"
};
export default data;
